import { Box } from '@mantine/core';

import { Declaration } from '@e-origin/shared';

import { IconFactory } from '@assets';
import { IconBox } from '@components';
import { extractDeclarationStatusByIcon } from './utils';

interface DeclarationLVStatusIndicatorProps {
  declaration: Declaration;
}

export const DeclarationLVStatusIndicator: React.FC<DeclarationLVStatusIndicatorProps> = ({ declaration }) => {
  if (declaration.generalInfo.complianceCheck) {
    return (
      <Box display={'flex'}>
        {declaration.goodShipmentGlobal?.splitShipment ? (
          <IconBox
            icon={IconFactory.anomaliesHSCodeOrDescription}
            alt={'anomalies-detected-value'}
            title={extractDeclarationStatusByIcon(IconFactory.anomaliesHSCodeOrDescription)}
          />
        ) : (
          <IconBox icon={IconFactory.noSentAnomalies} alt={'no-anomalies-detected-value'} title={extractDeclarationStatusByIcon(IconFactory.noSentAnomalies)} />
        )}
      </Box>
    );
  }

  if (declaration.goodShipmentGlobal?.wrongIOSS || declaration.goodShipmentGlobal?.undervaluation) {
    return (
      <Box display={'flex'}>
        <IconBox
          icon={IconFactory.anomaliesHSCodeOrDescription}
          alt={'anomalies-detected-value'}
          title={extractDeclarationStatusByIcon(IconFactory.anomaliesHSCodeOrDescription)}
        />
      </Box>
    );
  }

  return (
    <Box display={'flex'}>
      <IconBox icon={IconFactory.notSent} alt={'no-risk-analysis-done'} title={extractDeclarationStatusByIcon(IconFactory.notSent)} />
    </Box>
  );
};
